module.exports = __webpack_public_path__ + "static/img/up.822c5522.svg";